import { connect, ConnectedProps } from 'react-redux'
import TablePackagings from '../../../../../../../../specificComponents/Product/Tables/TablePackagings'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { SpecificPriceRulesPayload } from '../../../../../../../../utils/reducers/products/specificPriceRules'
import { ModalFullCentered, CloseLateralModalSimple } from '../../../../../../../Modal'
import { ModalEditComponentProps } from '../../../../../../../ModalsLayouts/types'


type PackagingListingModalProps = ReduxTablePackagings & ModalEditComponentProps & {}

const PackagingListingModal: React.FC<PackagingListingModalProps> = ({...rest}) => {
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal'>
            <CloseLateralModalSimple onClose={() => rest.setOpened(null)} />
            <TablePackagingsConnect userPermissions={getUserPermissions('product.packaging.main') || { n: 1, permission: 'read' }} setOpened={() => rest.setOpened(null)} setTableInstance={() => { }} tableInstance={null} onRowClick={() => rest.setOpened(null)}/>
        </ModalFullCentered>
    )
}

const tablePackagingsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

const mapTablePackagingsConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const tablePackagingsConnect = connect(mapTablePackagingsConnector, tablePackagingsDispatch)
type ReduxTablePackagings = ConnectedProps<typeof tablePackagingsConnect>

const tablePackagingsConnectLoading = withLoading(TablePackagings, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const TablePackagingsConnect = tablePackagingsConnect(tablePackagingsConnectLoading)

export default PackagingListingModal